<demo-section [name]="name" [src]="src" [componentContent]="componentContent">
  <p>Add small overlay content, like those found in iOS, to any element for housing secondary information.</p>
  <p>The easiest way to add the popover component to your app (will be added to the root module)</p>
  <pre class="prettyprint lang-bash prettyprinted"><span class="pln">ng add ngx</span><span class="pun">-</span><span class="pln">bootstrap </span> --component <span class="pln">popover</span></pre>
  <docs-section [content]="componentContent"></docs-section>
</demo-section>
